// extracted by mini-css-extract-plugin
export default {"wrapper":"src-modules-page-blocks-CenterTextWithTitle-style__wrapper_H6bqC","text":"src-modules-page-blocks-CenterTextWithTitle-style__text_tc2BK"};